import { render, staticRenderFns } from "./mlPoster.vue?vue&type=template&id=2cecbe12&scoped=true&"
import script from "./mlPoster.vue?vue&type=script&lang=js&"
export * from "./mlPoster.vue?vue&type=script&lang=js&"
import style0 from "./mlPoster.vue?vue&type=style&index=0&id=2cecbe12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cecbe12",
  null
  
)

export default component.exports